import React, {useState, useEffect} from "react"

import Favourites from "./../data/favourites"

// context
const FavouritesContext = React.createContext()

// the provider
const FavouritesProvider = (props) => {
  // state
  const [favourites, setFavourites] = useState({})

  // mount
  useEffect(() => {
    // favourites
    let favs = Favourites.load()
    setFavourites({
      items:favs,
      count:favs.length
    })
  }, []) 
  
  // the value provided
  let value = {
    // data
    items:favourites.items,
    count:favourites.count,

    // functions
    add: (activity_id) => {
      let favs = Favourites.add(activity_id)
      setFavourites({
        items:favs,
        count:favs.length
      })
    },
    remove: (activity_id) => {
      let favs = Favourites.remove(activity_id)
      setFavourites({
        items:favs,
        count:favs.length
      })
    },
    isFavourite: (activity_id) => {
      return Favourites.isFavourite(activity_id)
    }
  }

  // render 
  return (
    <FavouritesContext.Provider value={value}>
      {props.children}
    </FavouritesContext.Provider>
  )
}


export {FavouritesContext, FavouritesProvider}


// TODO since we alredy have all the data in the context provider's state, is it really necessary to also store tin the data/catalogue, data/region, data/properties containers? ... all the data points at the same reference (I think), but still ...